import { baseCreateMuiTheme, Theme } from '@breathelife/mui';

import { createBaseMuiTheme, SharedTheme } from '@breathelife/ui-components';

const fontsFamilies = [
  '"-apple-system"', // "San Francisco", macOS / iOS default
  '"BlinkMacSystemFont"', // macOS / iOS default (Chrome only)
  '"Helvetica Neue"', // macOS / iOS default (older OSes)
  '"Segoe UI"', // Windows default
  '"Roboto"', // Android default
  '"sans-serif"',
].join(',');

export function createMuiTheme(theme: SharedTheme): Theme {
  return baseCreateMuiTheme({
    ...createBaseMuiTheme(theme),
    breakpoints: {
      // Approximate to our internal breakpoints
      values: {
        xs: 0,
        sm: 300,
        md: 768,
        lg: 1024,
        xl: 1600,
      },
    },
    palette: {
      primary: { main: theme.colors.primary.default ?? theme.colors.primary[50] },
      secondary: { main: theme.colors.secondary.default ?? theme.colors.secondary[50] },
    },
    typography: {
      fontSize: 16,
      // Use system font instead of using Roboto on all platforms
      fontFamily: fontsFamilies,
      button: {
        fontSize: 13,
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true, // Disable ripple animation on click
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            letterSpacing: 0.2,
          },
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          colorPrimary: {
            margin: '1em',
            color: `${theme.colors.primary.default} !important`,
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            marginLeft: 0,
            marginRight: 0,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: theme.colors.grey[50],
          },
          root: {
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.colors.text.error,
            },
            '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.colors.grey[60],
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: 3,
              borderColor: theme.colors.hyperlink,
            },
            '&.Mui-focused .MuiOutlinedInput-input': {
              caretColor: theme.colors.primary[40],
            },
          },
        },
      },
      MuiSnackbar: {
        defaultProps: {
          TransitionComponent: ({ children }) => children,
        },
      },
    },
  });
}
